import Cookies from './Cookies'
import { uniq } from './array'

export const COOKIE_NAME = 'slite-orgs'
export function saveOrganizationAsJoined(
  domain,
  organizationId,
  cookiesHelper = Cookies
) {
  cookiesHelper.set(
    COOKIE_NAME,
    uniq([...listJoinedOrganizations(cookiesHelper), organizationId]),
    { domain }
  )
}

export function listJoinedOrganizations(cookiesHelper = Cookies) {
  const cookie = cookiesHelper.get(COOKIE_NAME)
  return (cookie && uniq(cookie.value)) || []
}

export function removeOrganizationFromJoined(
  domain,
  organizationId,
  cookiesHelper = Cookies
) {
  cookiesHelper.set(
    COOKIE_NAME,
    listJoinedOrganizations(cookiesHelper).filter(id => id !== organizationId),
    { domain }
  )
}
